import { useTranslate } from "@refinedev/core";
import { Button, SectionHeader } from "@fawkes/ui";

import { OpvangcategorieManagement } from "./OpvangcategorieManagement";
import type { SettingsContext } from "./tiles/types";

// settings-pleeggezinnen: the Pleeggezinnen tile's detail screen — the React port of the Jmix
// "Pleeggezinnen" settings. Hosts the migrated "Opvangcategorieën" (care categories) sub-item
// (OpvangcategorieManagement) for the active branch. Branch-scoped: the dashboard only opens this in a
// branch context, so context.vestigingId is present. Rendered in-place by SettingsDashboard's detail
// switch with a "Terug" back button, mirroring the FinanceSettings detail pattern.
export function PleeggezinnenSettings({
  context,
  onBack,
}: {
  context: SettingsContext;
  onBack: () => void;
}) {
  const t = useTranslate();
  const vestigingId = context.vestigingId ?? 0;
  return (
    <div className="settings-finance-settings">
      <div className="settings-finance-detail-toolbar">
        <Button variant="secondary" onClick={onBack}>
          {t("common.back")}
        </Button>
        <SectionHeader>{t("instellingen.tile.pleeggezinnen.title")}</SectionHeader>
      </div>
      <p className="fawkes-muted settings-finance-detail__breadcrumb">
        {`${t("instellingen.title")} › ${context.label} › ${t("instellingen.tile.pleeggezinnen.title")}`}
      </p>

      <OpvangcategorieManagement vestigingId={vestigingId} />
    </div>
  );
}
